import { AppConfigModel } from '../abstract/app-config.model';
import { ModelBase } from '../abstract/model-base.model';
import { Account } from '../accounting/account.model';
import { AccountEntry } from '../accounting/account-entry.model';
import { AccountEntryExport } from '../accounting/account-entry-export.model';
import { AccountEntryExportFormat } from '../accounting/account-entry-export-format.model';
import { AccountEntryLine } from '../accounting/account-entry-line.model';
import { AccountEntryNumberRange } from '../accounting/account-entry-number-range.model';
import { AccountEntryType } from '../accounting/account-entry-type.model';
import { AccountStatement } from '../accounting/account-statement.model';
import { AccountStatementTransaction } from '../accounting/account-statement-transaction.model';
import { AccountingMethod } from '../accounting/accounting-method.model';
import { AccountingPeriod } from '../accounting/accounting-period.model';
import { AccountingSettings } from '../accounting/accounting-settings.model';
import { Address } from '../address/address.model';
import { AddressFormat } from '../address/address-format.model';
import { AllocationType } from '../accounting/allocation-type.model';
import { AgentAction } from '../ai/agent-action.model';
import { AgentMarker } from '../ai/agent-marker.model';
import { AgentMonthlyUsage } from '../ai/agent-monthly-usage.model';
import { AgentSession } from '../ai/agent-session.model';
import { AgentToolCall } from '../ai/agent-tool-call.model';
import { AgentTurn } from '../ai/agent-turn.model';
import { AiSettings } from '../ai/ai-settings.model';
import { AnalyticalAxis } from '../analytical/analytical-axis.model';
import { AnalyticalAxisState } from '../analytical/analytical-axis-state.model';
import { AnalyticalCarrierStatus } from '../analytical/analytical-carrier-status.model';
import { AnalyticalDefault } from '../analytical/analytical-default.model';
import { AnalyticalDistribution } from '../analytical/analytical-distribution.model';
import { AnalyticalDistributionSection } from '../analytical/analytical-distribution-section.model';
import { AnalyticalDocumentStatus } from '../analytical/analytical-document-status.model';
import { AnalyticalKey } from '../analytical/analytical-key.model';
import { AnalyticalKeyPart } from '../analytical/analytical-key-part.model';
import { AnalyticalSection } from '../analytical/analytical-section.model';
import { AnalyticalVentilationState } from '../analytical/analytical-ventilation-state.model';
import { Announcement } from '../announcements/announcement.model';
import { ApiKey } from '../client/api-key.model';
import { AssistantAuthorizationRequest } from '../interfaces/assistant-authorization-request.model';
import { AssistantClient } from '../interfaces/assistant-client.model';
import { AssistantGrant } from '../interfaces/assistant-grant.model';
import { Authorization } from '../authorization/authorization.model';
import { Bank } from '../banking/config/bank.model';
import { BankAccount } from '../banking/bank-accounts/bank-account.model';
import { BankAccountLine } from '../banking/bank-account-lines/bank-account-line.model';
import { BankAccountLineAllocation } from '../banking/bank-account-lines/bank-account-line-allocation.model';
import { BankAccountLineQualificationSource } from '../banking/bank-account-lines/bank-account-line-qualification-source.model';
import { BankAccountLineType } from '../banking/config/transaction-type.model';
import { BankAccountRule } from '../banking/rules/bank-account-rule.model';
import { BankAccountRuleAllocation } from '../banking/rules/bank-account-rule-allocation.model';
import { BankAccountType } from '../banking/config/bank-account-type.model';
import { BankingSettings } from '../banking/banking-settings.model';
import { BankStatement } from '../banking/statements/bank-statement.model';
import { BankStatementAutomation } from '../banking/config/bank-statement-automation.model';
import { BankStatementLine } from '../banking/statements/bank-statement-line.model';
import { BusinessEvent } from '../kpi/business-event.model';
import { CardReceipt } from '../banking/cards/card-receipt.model';
import { CardReceiptAllocation } from '../banking/cards/card-receipt-allocation.model';
import { CashTransaction } from '../banking/cash-transactions/cash-transaction.model';
import { CashTransactionAllocation } from '../banking/cash-transactions/cash-transaction-allocation.model';
import { Cheque } from '../banking/cheques/cheque.model';
import { ChequeAllocation } from '../banking/cheques/cheque-allocation.model';
import { ChequeRefusalReason } from '../banking/cheques/cheque-refusal-reason.model';
import { City } from '../address/city.model';
import { Civility } from '../user/civility.model';
import { Client } from '../client/client.model';
import { ClientAccountEntryType } from '../accounting/client-account-entry-type.model';
import { ClientContact } from '../client/contact.model';
import { ClientProfileMfa } from '../authorization/client-profile-mfa.model';
import { MfaPolicy } from '../authorization/mfa-policy.model';
import { ClientTax } from '../accounting/client-tax.model';
import { ClientUser } from '../client/client-user.model';
import { ClientUserNotificationSetting } from '../notifications/client-user-notification-setting.model';
import { Conversation } from '../messaging/conversation.model';
import { ConversationItem } from '../messaging/conversation-item.model';
import { Country } from '../core/country.model';
import { CreditCard } from '../banking/credit-cards/credit-card.model';
import { CreditCardTransaction } from '../banking/credit-card-transactions/credit-card-transaction.model';
import { CreditCardTransactionAllocation } from '../banking/credit-card-transactions/credit-card-transaction-allocation.model';
import { Currency } from '../core/currency.model';
import { CustomProfile } from '../authorization/custom-profile.model';
import { Deposit } from '../banking/cheques/deposit.model';
import { DiscountType } from '../sales/discount-type.model';
import { DocumentEmailType } from '../messaging/document-email-type.model';
import { Downpayment } from '../sales/invoice/downpayment.model';
import { EcoTaxSector } from '../product/eco-tax-sector.model';
import { Email } from '../messaging/email.model';
import { EmailEvent } from '../messaging/email-event.model';
import { EmailRedirection } from '../interfaces/email-redirection.model';
import { Employee } from '../human-resources/employee.model';
import { Establishment } from '../partner/establishment.model';
import { Feature } from '../subscription/feature.model';
import { File } from '../file/file.model';
import { Frequency } from '../core/frequency.model';
import { ImportBatch } from '../imports/import-batch.model';
import { ImportRow } from '../imports/import-row.model';
import { InsertableBankDetails } from '../banking/bank-accounts/insertable-bank-details.model';
import { Invite } from '../client/invite.model';
import { InvoiceContact } from '../sales/contact.model';
import { InvoiceNumbering } from '../sales/invoice-numbering.model';
import { InvoiceOrigin } from '../invoicing/invoice-origin.model';
import { InvoiceType } from '../invoicing/invoice-type.model';
import { ItemType } from '../sales/item-type.model';
import { Journal } from '../accounting/journal.model';
import { JournalType } from '../accounting/journal-type.model';
import { KpiBankAccountBalances, KpiBankAccountDailyBalance } from '../kpi/bank-account-balances.model';
import { KpiCharges } from '../kpi/charges.model';
import { KpiDso, KpiDsoMonth } from '../kpi/dso.model';
import { KpiMonthlySummary, KpiMonthSummary } from '../kpi/monthly-summary.model';
import { KpiPartnerDebts } from '../kpi/partner-debts.model';
import { LedgerEntry } from '../settlment/ledger-entry.model';
import { LedgerEntryType } from '../settlment/ledger-entry-type.model';
import { LegalConsent } from '../legal/legal-consent.model';
import { LegalDocument } from '../legal/legal-document.model';
import { LegalStatus } from '../taxation/legal-status.model';
import { Loan } from '../banking/loans/loan.model';
import { LoanDeferralMode } from '../banking/loans/loan-deferral-mode.model';
import { LoanEarlyRepaymentMode } from '../banking/loans/loan-early-repayment-mode.model';
import { LoanEvent } from '../banking/loans/loan-event.model';
import { LoanEventType } from '../banking/loans/loan-event-type.model';
import { LoanInstalment } from '../banking/loans/loan-instalment.model';
import { LoanInstalmentOrigin } from '../banking/loans/loan-instalment-origin.model';
import { LoanInstalmentPaymentStatus } from '../banking/loans/loan-instalment-payment-status.model';
import { LoanInsuranceMode } from '../banking/loans/loan-insurance-mode.model';
import { LoanPeriodicity } from '../banking/loans/loan-periodicity.model';
import { LoanRepaymentProfile } from '../banking/loans/loan-repayment-profile.model';
import { LoanState } from '../banking/loans/loan-state.model';
import { NotificationType } from '../notifications/notification-type.model';
import { NumericComparator } from '../core/numeric-comparator.model';
import { Onboarding } from '../onboarding/onboarding.model';
import { OnboardingStep } from '../onboarding/step.model';
import { OpenBankingStatus } from '../banking/bank-accounts/open-banking-status.model';
import { Organization } from '../legal-entity/organization.model';
import { OrganizationActivity } from '../legal-entity/organization-activity.model';
import { OrganizationIdentifierType } from '../legal-entity/organization-identifier-type.model';
import { OrganizationSize } from '../legal-entity/organization-size.model';
import { Package } from '../subscription/package.model';
import { PackageContent } from '../subscription/package-content.model';
import { Partner } from '../partner/partner.model';
import { PartnerAccountStatement } from '../partner/account-statement.model';
import { PartnerContact } from '../partner/contact.model';
import { PartnerGroup } from '../partner/partner-group.model';
import { PartnerIdentifier } from '../partner/partner-identifier.model';
import { PartnerResolutionStrategy } from '../invoicing/partner-resolution-strategy.model';
import { PartnerSalesSettings } from '../partner/partner-sales-settings.model';
import { PartnerType } from '../partner/partner-type.model';
import { PaymentInstallment } from '../sales/payment-schedule/installment.model';
import { PaymentMethod } from '../core/payment-method.model';
import { PaymentProvider } from '../banking/cards/payment-provider.model';
import { PaymentSchedule } from '../sales/payment-schedule/schedule.model';
import { PaymentTerm } from '../invoicing/payment-term.model';
import { Person } from '../person/abstract/person.model';
import { PersonNameOrder } from '../core/person-name-order.model';
import { PhoneAreaCode } from '../address/phone-area-code.model';
import { Pricing } from '../sales/pricing.model';
import { PricingMode } from '../core/pricing-mode.model';
import { Product } from '../product/product.model';
import { ProductGroup } from '../product/product-group.model';
import { ProductSectionTitle } from '../product/product-section-title.model';
import { ProductType } from '../product/product-type.model';
import { Profile } from '../authorization/profile.model';
import { PurchaseInvoice } from '../purchasing/invoice/purchase-invoice.model';
import { PurchaseInvoiceAllocation } from '../purchasing/invoice/purchase-invoice-allocation.model';
import { PurchaseInvoiceItem } from '../purchasing/invoice/purchase-invoice-item.model';
import { PurchaseInvoiceItemAllocation } from '../purchasing/invoice/purchase-invoice-item-allocation.model';
import { PurchaseInvoiceTax } from '../purchasing/invoice/purchase-invoice-tax.model';
import { Question } from '../help/question.model';
import { Quota } from '../subscription/quota.model';
import { Quotation } from '../sales/quotation/quotation.model';
import { QuotationItem } from '../sales/quotation/quotation-item.model';
import { QuotationTax } from '../sales/quotation/quotation-tax.model';
import { RecurringInvoice } from '../sales/recurring-invoice/recurring-invoice.model';
import { RecurringInvoiceEndingMode } from '../sales/recurring-invoice/ending-mode.model';
import { RecentlyUploadedDocument } from '../kpi/recently-uploaded-document.model';
import { Remuneration } from '../human-resources/remuneration.model';
import { SalesDocumentTemplate } from '../sales/template.model';
import { SalesDocumentType } from '../sales/sales-document-type.model';
import { SalesInvoice } from '../sales/invoice/sales-invoice.model';
import { SalesInvoiceAllocation } from '../sales/invoice/sales-invoice-allocation.model';
import { SalesInvoiceItem } from '../sales/invoice/sales-invoice-item.model';
import { SalesInvoiceItemAllocation } from '../sales/invoice/sales-invoice-item-allocation.model';
import { SalesInvoiceTax } from '../sales/invoice/sales-invoice-tax.model';
import { SalesSettings } from '../sales/sales-settings.model';
import { SellingInfoRecord } from '../sales/selling-info-record.model';
import { Settlement } from '../settlment/settlement.model';
import { Shareholder } from '../client/shareholder.model';
import { Subsidy } from '../accounting/subsidy.model';
import { Subscription } from '../subscription/subscription.model';
import { Tax } from '../core/tax.model';
import { TaxDetail } from '../core/taxDetail.model';
import { TaxationRegime } from '../taxation/taxation-regime.model';
import { TaxationSettings } from '../taxation/taxation-settings.model';
import { TaxationType } from '../taxation/taxation-type.model';
import { TgcDeclaration } from '../taxation/tgc-declaration.models';
import { TgcDeclarationFieldInvoice } from '../taxation/tgc-declaration-field-invoice.model';
import { Timezone } from '../core/timezone.model';
import { TransactionDirection } from '../banking/config/transaction-direction.model';
import { Unit } from '../core/unit.model';
import { User } from '../user/user.model';
import { UserAuthorization } from '../client/user-authorization.model';
import { UserCustomProfile } from '../client/user-custom-profile.model';
import { UserNotificationSetting } from '../notifications/user-notification-setting.model';
import { UserProfile } from '../client/user-profile.model';
import { VatChargeability } from '../taxation/vat-chareability.model';
import { VatFrequency } from '../taxation/vat-frequency.model';

export class GeneralFactory {
    static get(className: string, data: any): ModelBase | AppConfigModel {
        switch (className) {
            case 'Account':
                return new Account(data);
            case 'AccountEntry':
                return new AccountEntry(data);
            case 'AccountEntryExport':
                return new AccountEntryExport(data);
            case 'AccountEntryExportFormat':
                return new AccountEntryExportFormat(data);
            case 'AccountEntryLine':
                return new AccountEntryLine(data);
            case 'AccountEntryNumberRange':
                return new AccountEntryNumberRange(data);
            case 'AccountEntryType':
                return new AccountEntryType(data);
            case 'AccountStatement':
                return new AccountStatement(data);
            case 'AccountStatementTransaction':
                return new AccountStatementTransaction(data);
            case 'AccountingMethod':
                return new AccountingMethod(data);
            case 'AccountingPeriod':
                return new AccountingPeriod(data);
            case 'AccountingSettings':
                return new AccountingSettings(data);
            case 'Address':
                return new Address(data);
            case 'AddressFormat':
                return new AddressFormat(data);
            case 'AllocationType':
                return new AllocationType(data);
            case 'AgentAction':
                return new AgentAction(data);
            case 'AgentMarker':
                return new AgentMarker(data);
            case 'AgentMonthlyUsage':
                return new AgentMonthlyUsage(data);
            case 'AgentSession':
                return new AgentSession(data);
            case 'AgentToolCall':
                return new AgentToolCall(data);
            case 'AgentTurn':
                return new AgentTurn(data);
            case 'AiSettings':
                return new AiSettings(data);
            case 'AnalyticalAxis':
                return new AnalyticalAxis(data);
            case 'AnalyticalAxisState':
                return new AnalyticalAxisState(data);
            case 'AnalyticalCarrierStatus':
                return new AnalyticalCarrierStatus(data);
            case 'AnalyticalDefault':
                return new AnalyticalDefault(data);
            case 'AnalyticalDistribution':
                return new AnalyticalDistribution(data);
            case 'AnalyticalDistributionSection':
                return new AnalyticalDistributionSection(data);
            case 'AnalyticalDocumentStatus':
                return new AnalyticalDocumentStatus(data);
            case 'AnalyticalKey':
                return new AnalyticalKey(data);
            case 'AnalyticalKeyPart':
                return new AnalyticalKeyPart(data);
            case 'AnalyticalSection':
                return new AnalyticalSection(data);
            case 'AnalyticalVentilationState':
                return new AnalyticalVentilationState(data);
            case 'Announcement':
                return new Announcement(data);
            case 'ApiKey':
                return new ApiKey(data);
            case 'AssistantAuthorizationRequest':
                return new AssistantAuthorizationRequest(data);
            case 'AssistantClient':
                return new AssistantClient(data);
            case 'AssistantGrant':
                return new AssistantGrant(data);
            case 'Authorization':
                return new Authorization(data);
            case 'Bank':
                return new Bank(data);
            case 'BankAccount':
                return new BankAccount(data);
            case 'BankAccountLine':
                return new BankAccountLine(data);
            case 'BankAccountLineAllocation':
                return new BankAccountLineAllocation(data);
            case 'BankAccountLineQualificationSource':
                return new BankAccountLineQualificationSource(data);
            case 'BankAccountLineType':
                return new BankAccountLineType(data);
            case 'BankAccountRule':
                return new BankAccountRule(data);
            case 'BankAccountRuleAllocation':
                return new BankAccountRuleAllocation(data);
            case 'BankAccountType':
                return new BankAccountType(data);
            case 'BankingSettings':
                return new BankingSettings(data);
            case 'BankStatement':
                return new BankStatement(data);
            case 'BankStatementAutomation':
                return new BankStatementAutomation(data);
            case 'BankStatementLine':
                return new BankStatementLine(data);
            case 'BusinessEvent':
                return new BusinessEvent(data);
            case 'CardReceipt':
                return new CardReceipt(data);
            case 'CardReceiptAllocation':
                return new CardReceiptAllocation(data);
            case 'CashTransaction':
                return new CashTransaction(data);
            case 'CashTransactionAllocation':
                return new CashTransactionAllocation(data);
            case 'Cheque':
                return new Cheque(data);
            case 'ChequeAllocation':
                return new ChequeAllocation(data);
            case 'ChequeRefusalReason':
                return new ChequeRefusalReason(data);
            case 'City':
                return new City(data);
            case 'Civility':
                return new Civility(data);
            case 'Client':
                return new Client(data);
            case 'ClientAccountEntryType':
                return new ClientAccountEntryType(data);
            case 'ClientContact':
                return new ClientContact(data);
            case 'ClientProfileMfa':
                return new ClientProfileMfa(data);
            case 'ClientUserNotificationSetting':
                return new ClientUserNotificationSetting(data);
            case 'ClientTax':
                return new ClientTax(data);
            case 'ClientUser':
                return new ClientUser(data);
            case 'Conversation':
                return new Conversation(data);
            case 'ConversationItem':
                return new ConversationItem(data);
            case 'Country':
                return new Country(data);
            case 'CreditCard':
                return new CreditCard(data);
            case 'CreditCardTransaction':
                return new CreditCardTransaction(data);
            case 'CreditCardTransactionAllocation':
                return new CreditCardTransactionAllocation(data);
            case 'Currency':
                return new Currency(data);
            case 'CustomProfile':
                return new CustomProfile(data);
            case 'Deposit':
                return new Deposit(data);
            case 'DiscountType':
                return new DiscountType(data);
            case 'DocumentEmailType':
                return new DocumentEmailType(data);
            case 'Downpayment':
                return new Downpayment(data);
            case 'EcoTaxSector':
                return new EcoTaxSector(data);
            case 'Email':
                return new Email(data);
            case 'EmailEvent':
                return new EmailEvent(data);
            case 'EmailRedirection':
                return new EmailRedirection(data);
            case 'Employee':
                return new Employee(data);
            case 'Establishment':
                return new Establishment(data);
            case 'Feature':
                return new Feature(data);
            case 'File':
                return new File(data);
            case 'Frequency':
                return new Frequency(data);
            case 'ImportBatch':
                return new ImportBatch(data);
            case 'ImportRow':
                return new ImportRow(data);
            case 'InsertableBankDetails':
                return new InsertableBankDetails(data);
            case 'Invite':
                return new Invite(data);
            case 'InvoiceContact':
                return new InvoiceContact(data);
            case 'InvoiceNumbering':
                return new InvoiceNumbering(data);
            case 'InvoiceOrigin':
                return new InvoiceOrigin(data);
            case 'InvoiceType':
                return new InvoiceType(data);
            case 'ItemType':
                return new ItemType(data);
            case 'Journal':
                return new Journal(data);
            case 'JournalType':
                return new JournalType(data);
            case 'KpiBankAccountBalances':
                return new KpiBankAccountBalances(data);
            case 'KpiBankAccountDailyBalance':
                return new KpiBankAccountDailyBalance(data);
            case 'KpiCharges':
                return new KpiCharges(data);
            case 'KpiMonthSummary':
                return new KpiMonthSummary(data);
            case 'KpiDso':
                return new KpiDso(data);
            case 'KpiDsoMonth':
                return new KpiDsoMonth(data);
            case 'KpiMonthlySummary':
                return new KpiMonthlySummary(data);
            case 'KpiPartnerDebts':
                return new KpiPartnerDebts(data);
            case 'LedgerEntry':
                return new LedgerEntry(data);
            case 'LedgerEntryType':
                return new LedgerEntryType(data);
            case 'LegalConsent':
                return new LegalConsent(data);
            case 'LegalDocument':
                return new LegalDocument(data);
            case 'LegalStatus':
                return new LegalStatus(data);
            case 'Loan':
                return new Loan(data);
            case 'LoanDeferralMode':
                return new LoanDeferralMode(data);
            case 'LoanEarlyRepaymentMode':
                return new LoanEarlyRepaymentMode(data);
            case 'LoanEvent':
                return new LoanEvent(data);
            case 'LoanEventType':
                return new LoanEventType(data);
            case 'LoanInstalment':
                return new LoanInstalment(data);
            case 'LoanInstalmentOrigin':
                return new LoanInstalmentOrigin(data);
            case 'LoanInstalmentPaymentStatus':
                return new LoanInstalmentPaymentStatus(data);
            case 'LoanInsuranceMode':
                return new LoanInsuranceMode(data);
            case 'LoanPeriodicity':
                return new LoanPeriodicity(data);
            case 'LoanRepaymentProfile':
                return new LoanRepaymentProfile(data);
            case 'LoanState':
                return new LoanState(data);
            case 'MfaPolicy':
                return new MfaPolicy(data);
            case 'NotificationType':
                return new NotificationType(data);
            case 'NumericComparator':
                return new NumericComparator(data);
            case 'Onboarding':
                return new Onboarding(data);
            case 'OnboardingStep':
                return new OnboardingStep(data);
            case 'OpenBankingStatus':
                return new OpenBankingStatus(data);
            case 'Organization':
                return new Organization(data);
            case 'OrganizationActivity':
                return new OrganizationActivity(data);
            case 'OrganizationIdentifierType':
                return new OrganizationIdentifierType(data);
            case 'OrganizationSize':
                return new OrganizationSize(data);
            case 'Package':
                return new Package(data);
            case 'PackageContent':
                return new PackageContent(data);
            case 'Partner':
                return new Partner(data);
            case 'PartnerAccountStatement':
                return new PartnerAccountStatement(data);
            case 'PartnerContact':
                return new PartnerContact(data);
            case 'PartnerGroup':
                return new PartnerGroup(data);
            case 'PartnerIdentifier':
                return new PartnerIdentifier(data);
            case 'PartnerResolutionStrategy':
                return new PartnerResolutionStrategy(data);
            case 'PartnerSalesSettings':
                return new PartnerSalesSettings(data);
            case 'PartnerType':
                return new PartnerType(data);
            case 'PaymentInstallment':
                return new PaymentInstallment(data);
            case 'PaymentMethod':
                return new PaymentMethod(data);
            case 'PaymentProvider':
                return new PaymentProvider(data);
            case 'PaymentSchedule':
                return new PaymentSchedule(data);
            case 'PaymentTerm':
                return new PaymentTerm(data);
            case 'Person':
                return new Person(data);
            case 'PersonNameOrder':
                return new PersonNameOrder(data);
            case 'PhoneAreaCode':
                return new PhoneAreaCode(data);
            case 'Pricing':
                return new Pricing(data);
            case 'PricingMode':
                return new PricingMode(data);
            case 'Product':
                return new Product(data);
            case 'ProductGroup':
                return new ProductGroup(data);
            case 'ProductSectionTitle':
                return new ProductSectionTitle(data);
            case 'ProductType':
                return new ProductType(data);
            case 'Profile':
                return new Profile(data);
            case 'PurchaseInvoice':
                return new PurchaseInvoice(data);
            case 'PurchaseInvoiceAllocation':
                return new PurchaseInvoiceAllocation(data);
            case 'PurchaseInvoiceItem':
                return new PurchaseInvoiceItem(data);
            case 'PurchaseInvoiceItemAllocation':
                return new PurchaseInvoiceItemAllocation(data);
            case 'PurchaseInvoiceTax':
                return new PurchaseInvoiceTax(data);
            case 'Question':
                return new Question(data);
            case 'Quota':
                return new Quota(data);
            case 'Quotation':
                return new Quotation(data);
            case 'QuotationItem':
                return new QuotationItem(data);
            case 'QuotationTax':
                return new QuotationTax(data);
            case 'RecentlyUploadedDocument':
                return new RecentlyUploadedDocument(data);
            case 'Remuneration':
                return new Remuneration(data);
            case 'RecurringInvoice':
                return new RecurringInvoice(data);
            case 'RecurringInvoiceEndingMode':
                return new RecurringInvoiceEndingMode(data);
            case 'SalesDocumentTemplate':
                return new SalesDocumentTemplate(data);
            case 'SalesDocumentType':
                return new SalesDocumentType(data);
            case 'SalesInvoice':
                return new SalesInvoice(data);
            case 'SalesInvoiceAllocation':
                return new SalesInvoiceAllocation(data);
            case 'SalesInvoiceItem':
                return new SalesInvoiceItem(data);
            case 'SalesInvoiceItemAllocation':
                return new SalesInvoiceItemAllocation(data);
            case 'SalesInvoiceTax':
                return new SalesInvoiceTax(data);
            case 'SalesSettings':
                return new SalesSettings(data);
            case 'SellingInfoRecord':
                return new SellingInfoRecord(data);
            case 'Settlement':
                return new Settlement(data);
            case 'Shareholder':
                return new Shareholder(data);
            case 'Subscription':
                return new Subscription(data);
            case 'Subsidy':
                return new Subsidy(data);
            case 'Tax':
                return new Tax(data);
            case 'TaxDetail':
                return new TaxDetail(data);
            case 'TaxationRegime':
                return new TaxationRegime(data);
            case 'TaxationSettings':
                return new TaxationSettings(data);
            case 'TaxationType':
                return new TaxationType(data);
            case 'TgcDeclaration':
                return new TgcDeclaration(data);
            case 'TgcDeclarationFieldInvoice':
                return new TgcDeclarationFieldInvoice(data);
            case 'Timezone':
                return new Timezone(data);
            case 'TransactionDirection':
                return new TransactionDirection(data);
            case 'Unit':
                return new Unit(data);
            case 'User':
                return new User(data);
            case 'UserAuthorization':
                return new UserAuthorization(data);
            case 'UserCustomProfile':
                return new UserCustomProfile(data);
            case 'UserNotificationSetting':
                return new UserNotificationSetting(data);
            case 'UserProfile':
                return new UserProfile(data);
            case 'VatChargeability':
                return new VatChargeability(data);
            case 'VatFrequency':
                return new VatFrequency(data);
            default:
                let message = 'Class ' + className + ' not defined in GeneralFactory'
                console.error(message);
                throw message;
        }
    }
}
